import styled from 'styled-components';

export const FormTextFieldStyled = styled.div`
  .box_input_item {
    width: 100%;
    .inline_prefix_container {
      display: flex;
      align-items: center;
      gap: 12px;
      > *:last-child {
        flex: 1;
        min-width: 0;
      }
    }
    .inline_prefix {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-shrink: 0;
      white-space: nowrap;
      font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
      font-size: ${({ theme }) => theme.FONT.SIZE.S18};
      color: ${({ theme }) => theme.COLORS.GRAY_23};
    }
    .label_row {
      position: relative;
    }
    .char_count {
      position: absolute;
      right: 0;
      bottom: 0;
      font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      color: ${({ theme }) => theme.COLORS.GRAY_4};
    }
  }
`;

export default FormTextFieldStyled;
